import React, { useState, useRef, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  SideCancelBtn,
  SelectionCard,
  Wrapper,
  CombineInputGroup,
  ActionSection,
  ScrollableContent,
  FieldWrappers,
  RupeeIcon,
  ModalHeader,
} from "../Styles/InputStyles";
import { capitalizeFirstLetter } from "../../helpers";
import CategoryCard from "../CategoryCard";
import SelectItemModal from "../SelectItemModal";
import { extraChargeOptions } from "../../utilities/extraChargeConfig";


const AddExtraCharges = ({ handleClose, addExtraChargesLoading, addExtraChargesMutate, propId, propertyDetails }) => {
  let formikRef = useRef(null);
  const [height, setHeight] = useState(window.innerHeight);
  const [typeModalOpen, setTypeModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    const handleResize = () => {
      setHeight(window.innerHeight); // updates when Safari UI changes
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const initialValues = {
    type: "",
    chargesType: "amount",
    unit: "",
    amount: "",
    repetition: "",
    properties: [],
  };

  const repetition = [
    { value: 1, label: "One Time" },
    { value: 2, label: "Monthly" },
  ];

  // const type = [
  //   { value: 4, label: "Electricity" },
  //   { value: 5, label: "Registration" },
  //   { value: 6, label: "Tech Charges" },
  //   { value: 3, label: "Maintenance" },
  //   { value: 8, label: "Agreement Charge" },
  //   { value: 9, label: "Food" },
  //   { value: 19, label: "Move Out Charges" },
  //   { value: 17, label: "Laundry Charges" },
  //   { value: 14, label: "Maid Charges" },
  //   { value: 12, label: "Wifi Charges" },
  //   { value: 7, label: "Other" },
  // ];

  const chargesType = [
    { value: 1, label: "Amount" },
    { value: 2, label: "Unit" },
  ];
  const handleTypeSelect = (typeItem, setFieldValue) => {
    if (typeItem) {
      setFieldValue("type", typeItem.value);
      setSelectedType(typeItem);
      setFieldValue("amount", "");
      setFieldValue("repetition", "");
    } else {
      setFieldValue("type", "");
      setSelectedType(null);
      setFieldValue("amount", "");
      setFieldValue("repetition", "");
    }
    setTypeModalOpen(false);
  };
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const amountDepositRegex = /^\d{1,6}$/;
    const maxAmountDeposit = 1000000;
    if (!values.type) {
      toast.error("Type is required");
      setSubmitting(false);
      return;
    }

    if (values.type === "Electricity" && !values.chargesType) {
      toast.error("Charges Type is required");
      setSubmitting(false);
      return;
    }

    if (values.chargesType === "unit" && !values.unit) {
      toast.error("Price per unit is required");
      setSubmitting(false);
      return;
    }

    if (values.type === 4 && values.chargesType === 2) {
      if (values.amount && !/^\d*\.?\d*$/.test(values.amount)) {
        toast.error("Price per unit must be a valid number");
        setSubmitting(false);
        return;
      }

      const amountValue = parseFloat(values.amount);
      if (isNaN(amountValue) || amountValue < 0.1 || amountValue > 100) {
        toast.error("Price per unit must be between 0.1 and 100");
        setSubmitting(false);
        return;
      }
    } else {
      if (values.amount && !/^\d*$/.test(values.amount)) {
        toast.error("Amount must be a number");
        setSubmitting(false);
        return;
      }

      if (values.chargesType === 2) {
        if (Number(values.amount) < 1 || Number(values.amount) > 100) {
          toast.error("Amount must be between 1 and 100");
          setSubmitting(false);
          return;
        }
      }

      if (values.type != 4 && values.chargesType != 1) {
        if (!amountDepositRegex.test(values.amount) || Number(values.amount) > maxAmountDeposit || Number(values.amount) < 1) {
          toast.error("Amount must be between 1 and 10,00,000 and contain only numbers");
          setSubmitting(false);
          return;
        }
      }
    }

    if (!values.repetition) {
      toast.error("Repetition is required");
      setSubmitting(false);
      return;
    }
    addExtraChargesMutate({
      type: values.type,
      repetitionType: values.repetition,
      amount: Number(values.amount),
      propertyList: [propId]
      // propertyList: propId
    })
    setSubmitting(false);
    resetForm();
  };

  return (
    <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">Add Extra Charges</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <ProfileSection className="flex justify-between">
        <UserInfo>
          <span className="font-medium mb-0">
            {capitalizeFirstLetter(propertyDetails?.name)}
          </span>
          <span className="text-sm text-gray-600">
            {propertyDetails?.address}
          </span>
        </UserInfo>

      </ProfileSection>
      <div className="px-6 h-full flex flex-col justify-between">
        <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit} >
          {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => {

            return (<Form>
              <ScrollableContent>
                <Wrapper>
                  <InputGroup>
                    <Label htmlFor="type">Type *</Label>
                    {/* <Select
                      name="type"
                      id="type"
                      className="w-full pl-2"
                      value={values.type}
                      onChange={(e) => {
                        setFieldValue("type", e.target.value);
                        setFieldValue("amount", "");
                        setFieldValue("repetition", "");
                      }}
                      onBlur={handleBlur}
                      style={{ height: "46px" }}
                    >
                      {type.map((type) => (
                        <MenuItem key={type.value} value={type.value}>
                          {type.label}
                        </MenuItem>
                      ))}
                    </Select> */}
                    <CategoryCard
                      title="Type"
                      selectedCategory={selectedType}
                      onClick={() => setTypeModalOpen(true)}
                    />
                  </InputGroup>

                  {values.type === 4 && (
                    <>
                      <InputGroup>
                        <Label>Charges Type *</Label>
                        <CardWrapper>
                          {chargesType.map((mode) => (
                            <SelectionCard
                              key={mode.value}
                              type="button"

                              onClick={() => {
                                setFieldValue("chargesType", mode.value);
                                setFieldValue("amount", "");
                              }}
                              className={
                                values.chargesType === mode.value
                                  ? "bg-[#0078BD] text-white"
                                  : "bg-gray-100"
                              }
                            >
                              <span className="text-sm">{mode.label}</span>
                            </SelectionCard>
                          ))}
                        </CardWrapper>
                      </InputGroup>


                    </>
                  )}

                  {(values.type !== 4 || (values.type === 4 && values.chargesType === 2)) && (
                    <InputGroup>
                      <Label htmlFor="amount">
                        {values.type === 4 && values.chargesType === 2 ? 'Price per unit' : 'Amount'}
                      </Label>

                      <FieldWrappers>
                        <RupeeIcon />
                        <Field
                          type="text"
                          name="amount"
                          id="amount"
                          inputMode={values.type === 4 && values.chargesType === 2 ? "decimal" : "numeric"}
                          className="w-full truncate pl-6"
                          value={values.amount}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (values.type === 4 && values.chargesType === 2) {

                              if (/^\d*\.?\d*$/.test(value) || value === '') {
                                setFieldValue("amount", value);
                              }
                            } else {

                              if (/^\d*$/.test(value)) {
                                setFieldValue("amount", value);
                              }
                            }
                          }}
                          onBlur={handleBlur}
                          placeholder={values.type === 4 && values.chargesType === 2 ? "0.00" : "0"}
                        />
                      </FieldWrappers>
                    </InputGroup>
                  )}


                  <InputGroup>
                    <Label>Repetition *</Label>
                    <CardWrapper>
                      {repetition.map((mode) => {
                        const isDisabled =
                          ((values.type === 4 ||
                            values.type === 3) &&
                            mode.value === 1) ||
                          ((values.type === 5 || values.type === 8 || values.type === 19) &&
                            mode.value === 2);
                        return (
                          <SelectionCard
                            key={mode.value}
                            type="button"
                            onClick={() => {
                              if (!isDisabled)
                                setFieldValue("repetition", mode.value);
                            }}
                            className={
                              values.repetition === mode.value
                                ? "bg-[#0078BD] text-white"
                                : isDisabled
                                  ? "bg-gray-200 cursor-not-allowed"
                                  : "bg-gray-100"
                            }
                          >
                            <span className="text-sm">{mode.label}</span>
                          </SelectionCard>
                        );
                      })}
                    </CardWrapper>
                  </InputGroup>

                </Wrapper>
              </ScrollableContent>
              <ActionSection>
                <SideCancelBtn type="button" onClick={handleClose}>
                  Cancel
                </SideCancelBtn>
                <SubmitBtn type="submit" disabled={addExtraChargesLoading}>{addExtraChargesLoading ? "Submitting..." : "Submit"}</SubmitBtn>
              </ActionSection>
              <SelectItemModal
                isOpen={typeModalOpen}
                onClose={() => setTypeModalOpen(false)}
                onSelect={(typeItem) => handleTypeSelect(typeItem, setFieldValue)}
                options={extraChargeOptions}
                selectedItem={selectedType}
                title="Select Type"
                searchPlaceholder="Search types..."
                idKey="value"
                nameKey="label"
                descriptionKeys={[]}
                emptyMessage="No types available"
                noResultsMessage="No types found"
                showClearSelection={true}
              />
            </Form>)
          }}
        </Formik>
      </div>
    </Container>
  );
};


const CardWrapper = tw.div`flex flex-wrap gap-2 my-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
export default AddExtraCharges;